module.exports = __webpack_public_path__ + "static/Hawaii1Sm-ab68bc452721f0db3a85833bd41cc52a.jpg";